// Import jQuery
import $ from 'jquery';

window.$ = $;
import './modules/MegaMenu';
import './modules/Splide';
